// nova API requests
document.addEventListener('DOMContentLoaded', function () {
    function initNova() {
        const novaPoshta = document.querySelector('#nova-poshta');
        const addressWrap = novaPoshta.querySelector('.address-wrap');
        const warehouseWrap = novaPoshta.querySelector('.warehouse-wrap');
        const cityFilter = novaPoshta.querySelector('#city_filter');
        const citySearch = novaPoshta.querySelector('#city-search');
        const warehouseFilter = novaPoshta.querySelector('#warehouse_filter');
        const streetFilter = novaPoshta.querySelector('#street_filter');

        const apiKey = window.nova_api_key;
        const apiUrlN = window.nova_api_url;

        quickCityLink();
        clearFields();
        deliveryMethod();
        initCartUrl();

        async function reqAPI(data) {
            try {
                const response = await fetch(apiUrlN, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    credentials: 'same-origin',
                    cache: 'no-cache',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                return response.json();
            } catch (error) {
                //throw error;
                console.log('error');
            }
        }

        novaPoshta.querySelectorAll('input.form-control').forEach(function (item) {
            item.addEventListener('input', function () {
                if (item.value != '') {
                    if (item.classList.contains('input-city')) {
                        item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                        let customerCity = item.value;
                        reqAPI({
                            "apiKey": apiKey,
                            "modelName": "Address",
                            "calledMethod": "searchSettlements",
                            "methodProperties": {
                                "CityName": customerCity,
                                "Limit": "99",
                                "Page": "1"
                            }
                        })
                            .then(res => {
                                if (res.success) {
                                    let dataCities = res.data[0].Addresses;
                                    cityFilter.innerHTML = '';
                                    if (dataCities.length > 0) {
                                        dataCities.forEach(function (item, i) {
                                            cityFilter.insertAdjacentHTML('beforeend', `
                                                <a class="filter-link city-link link" data-city="${item.MainDescription}" data-delivery-ref="${item.DeliveryCity}" data-ref="${item.Ref}" data-present="${item.Present}" style="display:block;">${item.Present}</a>
                                            `)
                                        })
                                    }
                                    cityFilter.classList.add('active');
                                    cityFilterLink();
                                }
                            })
                            .catch(err => {
                                console.log('error request:', this)
                            })
                    } else if (item.classList.contains('input-warehouse') && citySearch.value != '') {
                        item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                        let findString = item.value;
                        let CityRef = citySearch.dataset.deliveryRef;
                        reqAPI({
                            "apiKey": apiKey,
                            "modelName": "Address",
                            "calledMethod": "getWarehouses",
                            "methodProperties": {
                                "FindByString": findString,
                                "CityRef": CityRef,
                                "Page": "1",
                                "Limit": "99"
                            }
                        })
                            .then(res => {
                                if (res.success) {
                                    let warehouses = res.data;
                                    warehouseFilter.innerHTML = '';
                                    warehouses.forEach(function (item, i) {
                                        warehouseFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.Description}' style="display:block;">${item.Description}</a>
                                        `)
                                    })
                                    warehouseFilter.classList.add('active');
                                    cityFilterLink();
                                }
                            })
                            .catch(err => {
                                console.log('error request:', this)
                            })
                    } else if (item.classList.contains('input-street') && citySearch.value != '') {
                        item.closest('.form-group').querySelector('.clear').classList.remove('d-none');
                        let findString = item.value;
                        let сityRef = citySearch.dataset.deliveryRef;
                        reqAPI({
                            "apiKey": apiKey,
                            "modelName": "Address",
                            "calledMethod": "getStreet",
                            "methodProperties": {
                                "CityRef": сityRef,
                                "FindByString": findString,
                                "Page": "1",
                                "Limit": "99"
                            }
                        })
                            .then(res => {
                                if (res.success) {
                                    let dataStreets = res.data;
                                    streetFilter.innerHTML = '';
                                    dataStreets.forEach(function (item, i) {
                                        streetFilter.insertAdjacentHTML('beforeend', `
                                            <a class="filter-link city-link link" data-ref="${item.Ref}" data-present='${item.StreetsType} ${item.Description}' style="display:block;">${item.StreetsType} ${item.Description}</a>
                                        `)
                                    })
                                    streetFilter.classList.add('active');
                                    cityFilterLink();
                                }
                            })
                            .catch(err => {
                                console.log('error request:', this)
                            })
                    }
                } else {
                    item.dataset.ref = '';
                    if (item.closest('.form-group').querySelector('.clear') !== null) {
                        item.closest('.form-group').querySelector('.clear').classList.add('d-none')
                    }
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
                }
            })
        })

        function clearFields() {
            novaPoshta.querySelectorAll('.clear').forEach(function (item) {
                item.addEventListener('click', function () {
                    item.classList.add('d-none');
                    item.closest('.branch_wrap').querySelector('input').value = '';
                    item.closest('.branch_wrap').querySelector('input').dataset.ref = '';
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active')
                });
            });
        }

        function quickCityLink() {
            novaPoshta.querySelectorAll('a.quick-city-link').forEach(function (item) {
                let startCity = item.textContent;
                reqAPI({
                    "apiKey": apiKey,
                    "modelName": "Address",
                    "calledMethod": "searchSettlements",
                    "methodProperties": {
                        "CityName": startCity,
                        "Limit": "99",
                        "Page": "1"
                    }
                })
                    .then(res => {
                        if (res.success) {
                            item.dataset.ref = res.data[0].Addresses[0].Ref;
                            item.dataset.deliveryRef = res.data[0].Addresses[0].DeliveryCity;
                            item.dataset.present = res.data[0].Addresses[0].Present;
                        }
                    })
                    .catch(err => {
                        console.log('error request:', this)
                    })
                item.addEventListener('click', function (e) {
                    if (e.target.closest('.quick-city-link')) {
                        novaPoshta.querySelector('.city-wrap input').value = e.target.dataset.present;
                        novaPoshta.querySelector('.city-wrap input').dataset.ref = e.target.dataset.ref;
                        novaPoshta.querySelector('.city-wrap input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                        novaPoshta.querySelector('.city-wrap .clear').classList.remove('d-none');
                    }
                })
            })
        }

        function cityFilterLink() {
            novaPoshta.querySelectorAll('a.filter-link').forEach(function (item) {
                item.addEventListener('click', function (e) {
                    if (e.target.dataset.deliveryRef) {
                        item.closest('.branch_wrap').querySelector('.form-group input').dataset.deliveryRef = e.target.dataset.deliveryRef;
                    }
                    if (e.target.dataset.city) {
                        item.closest('.branch_wrap').querySelector('.form-group input').dataset.city = e.target.dataset.city;
                    }
                    item.closest('.branch_wrap').querySelector('.form-group input').dataset.ref = e.target.dataset.ref;
                    item.closest('.branch_wrap').querySelector('.form-group input').value = e.target.dataset.present;
                    item.closest('.branch_wrap').querySelector('.form-group .clear').classList.remove('d-none');
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').classList.remove('active');
                    item.closest('.branch_wrap').querySelector('.dropdown-filter').innerHTML = '';
                })
            })
        }

        function deliveryMethod() {
            document.querySelectorAll('[name="variant"]').forEach(function (item) {
                item.addEventListener('change', function (e) {
                    if (e.target.closest('#variant-branch')) {
                        addressWrap.classList.add('d-none');
                        warehouseWrap.classList.remove('d-none');
                        novaPoshta.querySelector('#address-street').value = '';
                        novaPoshta.querySelector('#address-street').dataset.ref = '';
                        novaPoshta.querySelector('#address-build').value = '';
                        novaPoshta.querySelector('#address-flat').value = '';
                        addressWrap.querySelector('.clear').classList.add('d-none');
                    } else if (e.target.closest('#variant-courier')) {
                        addressWrap.classList.remove('d-none');
                        warehouseWrap.classList.add('d-none');
                        novaPoshta.querySelector('#warehouse-search').value = '';
                        novaPoshta.querySelector('#warehouse-search').dataset.ref = '';
                        warehouseWrap.querySelector('.clear').classList.add('d-none');
                    }
                })
            })
        }

        function initCartUrl() {
            let inputsData = document.querySelectorAll('#nova-poshta .form-control');
            let inputsTypeShip = document.querySelectorAll('#nova-poshta input[name="variant"]');
            let buttCartLink = document.querySelector('#nova-poshta .nova-poshta__button-wrapper a');

            buttCartLink.addEventListener('click', function (e) {
                e.preventDefault();

                if (novaPoshta.querySelector('.dropdown-filter.active') == null) {
                    inputsTypeShip.forEach(function (inputTypeShip) {
                        if (inputTypeShip.checked && inputTypeShip.dataset.type == 'branch' && checkInputs('branch') == 2) {
                            let arrInputs = checkInputs('branch', true);
                            if (arrInputs) {
                                goToCheckout(arrInputs[0].value, arrInputs[1].value, '12345');
                            }
                        } else if (inputTypeShip.checked && inputTypeShip.dataset.type == 'courier' && checkInputs('courier') >= 3) {
                            let checkedInputs = checkInputs('courier', true);
                            if (checkedInputs) {
                                let address = checkedInputs[1].value + ', буд. ' + checkedInputs[2].value +
                                    (checkedInputs[3]?.value ? ', кв. ' + checkedInputs[3].value + ' ' : '');
                                goToCheckout(checkedInputs[0].value, address, '12345');
                            }
                        }
                    });
                } else {
                    console.log('select dates');
                }
            });

            function goToCheckout(city, address1, zip) {
                let giftMessageField = document.querySelector('#gift_card_message');
                let giftMessage = giftMessageField ? giftMessageField.value.trim() : '';

                // Спочатку зберігаємо і note, і attributes
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            'gift_card.message': giftMessage
                        },
                        note: giftMessage
                    })
                })
                    .then(() => {
                        // Переходимо на checkout з параметрами адреси
                        let checkoutUrl = '/checkout?' +
                            'checkout[shipping_address][city]=' + encodeURIComponent(city) +
                            '&checkout[shipping_address][address1]=' + encodeURIComponent(address1) +
                            '&checkout[shipping_address][zip]=' + encodeURIComponent(zip);

                        window.location.href = checkoutUrl;
                    })
                    .catch(err => console.error(err));
            }

            function checkInputs(type, returnInputs) {
                let arr = [];
                let count = 0;

                inputsData.forEach((item) => {
                    if (type === 'branch' &&
                        (item.id === 'city-search' || item.id === 'warehouse-search') &&
                        item.value !== '') {
                        count++;
                        arr.push(item);
                    }

                    if (type === 'courier' &&
                        (item.id === 'city-search' || item.id === 'address-street' || item.id === 'address-build' || item.id === 'address-flat') &&
                        item.value !== '') {
                        count++;
                        arr.push(item);
                    }
                });

                return returnInputs ? arr : count;
            }
        }

    }

    if (document.querySelector('#nova-poshta') !== null) {
        initNova();
    }
});
// nova API requests END

// filter popup
function initFilterPopup() {
    const toggleBtn = document.getElementById('filter-popup-toggle');
    const popup = document.getElementById('filter-popup');
    const overlay = document.getElementById('overlay');
    const elMain = document.getElementsByClassName("body");

    if (!toggleBtn || !popup) return;

    const closeButtons = popup.querySelectorAll('.js-close-filter');

    function closeFilterPopup() {
        popup.classList.remove('is-active');

        if (overlay) {
            overlay.classList.add('d-none');
        }

        if (elMain.length > 0) {
            elMain[0].classList.remove("no-overflow");
        }
    }

    function openFilterPopup() {
        popup.classList.add('is-active');

        if (overlay) {
            overlay.classList.remove('d-none');
        }

        if (elMain.length > 0) {
            elMain[0].classList.add("no-overflow");
        }
    }

    toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openFilterPopup();
    });

    if (closeButtons.length > 0) {
        closeButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                closeFilterPopup();
            });
        });
    }

    document.addEventListener('click', function (e) {
        if (
            popup.classList.contains('is-active') &&
            !popup.contains(e.target) &&
            !toggleBtn.contains(e.target)
        ) {
            closeFilterPopup();
        }
    });
}


function initSortPopup(){
    const toggleBtn = document.getElementById('sort-popup-toggle');
    const popup = document.getElementById('sortPopup');
    const elMain = document.getElementsByClassName("body");
    const  overlay = document.getElementById('overlay');
    if (!toggleBtn || !popup) return;
    const closeButtons = popup.querySelectorAll('.js-close-sort');

    function closeFilterPopup(){
        if(popup){
            popup.classList.remove('is-active');
        }
        if(overlay){
            overlay.classList.add('d-none');
        }
        if (elMain.length > 0) {
            elMain[0].classList.remove("no-overflow")
        }
    }

    function openFilterPopup(){
        if(popup){
            popup.classList.add('is-active');
        }
        if(overlay){
            overlay.classList.remove('d-none');
        }
        if (elMain.length > 0) {
            elMain[0].classList.add("no-overflow")
        }
    }

    toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openFilterPopup();
    });
    closeButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
            closeFilterPopup();
        });
    });
    document.addEventListener('click', function (e) {
        if(popup){
            if (
                popup.classList.contains('is-active') &&
                !popup.contains(e.target) &&
                !toggleBtn.contains(e.target)
            ) {
                closeFilterPopup();
            }
        }
    });
}
document.addEventListener('DOMContentLoaded', function () {
    initFilterPopup();
    initSortPopup();
});
// filter popup END


